import { Backdrop } from '@room-match/shared-ui-components';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSetHeaderBack } from 'shared/hooks/useSetHeader';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';
import { LeftContainer, MainContainer, RightContainer } from './PastSelfTape.styles';
import ProjectDetails from './ProjectDetails/ProjectDetails';
import RoleDetails from './RoleDetails/RoleDetails';
import Summary from './Summary/Summary';
import Information from './Information';
import Messaging from 'shared/components/Messaging/Messaging';

type Props = {
  auditionScheduleId: string;
};

const { getSpecificAuditionSchedule } = auditionScheduleService();
const PastSelfTape: React.FC<Props> = ({ auditionScheduleId }) => {
  const { data: auditionScheduleData, isLoading } = getSpecificAuditionSchedule(auditionScheduleId);
  const getAuditionScheduleData = useMemo(() => {
    if (isLoading) {
      return;
    } else {
      return auditionScheduleData ? auditionScheduleData?.data.audition_schedule : undefined;
    }
  }, [auditionScheduleData, isLoading]);

  const headshotUrl =
    getAuditionScheduleData?.audition?.profile?.primary_medium_attachment?.modified_attachment || null;

  const getRoleDetailsData = useMemo(() => {
    if (isLoading) {
      return;
    } else {
      return getAuditionScheduleData ? getAuditionScheduleData?.audition.casting_role : undefined;
    }
  }, [getAuditionScheduleData, isLoading]);

  const isNonRepre = useMemo(() => {
    if (isLoading) {
      return;
    } else {
      return getAuditionScheduleData?.audition?.profile?.agency ? false : true;
    }
  }, [getAuditionScheduleData, isLoading]);

  useSetHeaderBack(true);
  if (isLoading) return <Backdrop isLoading={true} />;
  else
    return (
      <MainContainer>
        <LeftContainer>
          <RoleDetails data={getRoleDetailsData} headshotUrl={headshotUrl} />
        </LeftContainer>
        <RightContainer>
          <ProjectDetails
            data={getRoleDetailsData}
            dateSubmitted={auditionScheduleData?.data?.audition_schedule?.checked_in_at}
            agency={
              auditionScheduleData && auditionScheduleData?.data?.audition_schedule?.audition?.profile.agency
                ? auditionScheduleData.data.audition_schedule.audition.profile.agency
                : undefined
            }
          />
          <Messaging
            messageKey={isNonRepre ? 'casting_talent_messages' : 'agent_talent_messages'}
            showEmpty
            type="new-audition-requests"
            id={auditionScheduleId}
            projectId={getRoleDetailsData?.project.id as string}
          />
          <Information auditionSchedule={getAuditionScheduleData} />
          <Summary data={getAuditionScheduleData} />
        </RightContainer>
      </MainContainer>
    );
};

export default PastSelfTape;
